import { useMutation } from '@tanstack/react-query'

import { aspidaClient } from '@/lib/aspida'
import { Language } from '@/lib/i18n/i18n'
import { MutationConfig } from '@/lib/react-query'

const updateLanguage = (language: Language) => {
  return aspidaClient.v1.user.language.$put({
    body: {
      languageCode: language,
    },
  })
}

export type UseUpdateLanguageOptions = {
  config?: MutationConfig<typeof updateLanguage>
}

export const useUpdateLanguage = ({ config }: UseUpdateLanguageOptions) => {
  const mutationConfig: MutationConfig<typeof updateLanguage> = {
    ...config,
    mutationFn: (language) => updateLanguage(language),
  }
  return useMutation(mutationConfig)
}
